import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import System from './components/System';
import Price from './components/Price';
import Experience from './components/Experience';
import Voice from './components/Voice';
import Access from './components/Access';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

const SITE_URL = import.meta.env.VITE_SITE_URL ?? 'https://golph.club';

const localBusinessJsonLd = {
  '@context': 'https://schema.org',
  '@type': ['LocalBusiness', 'SportsActivityLocation'],
  name: 'Golph.club Suminoe',
  alternateName: 'ゴルフクラブ住之江',
  description:
    '大阪市住之江区北加賀屋にある、UNEEKOR正規代理店が運営する完全貸切・無人のシミュレーションゴルフ施設。世界最高峰のUNEEKOR EYE XO2センサー搭載、1700以上のコースでプレー可能。',
  url: SITE_URL,
  telephone: '',
  priceRange: '¥5,000〜',
  image: `${SITE_URL}/og-image.jpg`,
  address: {
    '@type': 'PostalAddress',
    streetAddress: '中加賀屋２丁目８−１ 2F',
    addressLocality: '住之江区',
    addressRegion: '大阪府',
    addressCountry: 'JP',
    postalCode: '559-0011',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 34.6176105,
    longitude: 135.4805549,
  },
  hasMap: 'https://maps.google.com/?q=34.6176105,135.4805549',
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      opens: '06:00',
      closes: '23:55',
    },
  ],
  sameAs: ['https://www.instagram.com/golph.club/'],
  amenityFeature: [
    { '@type': 'LocationFeatureSpecification', name: 'シミュレーションゴルフ', value: true },
    { '@type': 'LocationFeatureSpecification', name: '完全貸切', value: true },
    { '@type': 'LocationFeatureSpecification', name: 'レンタルクラブ', value: true },
    { '@type': 'LocationFeatureSpecification', name: 'Wi-Fi', value: true },
    { '@type': 'LocationFeatureSpecification', name: '駐車場', value: true },
    { '@type': 'LocationFeatureSpecification', name: '更衣室', value: true },
  ],
};

const webSiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Golph.club Suminoe',
  url: SITE_URL,
  inLanguage: 'ja',
  description:
    '大阪市住之江区の完全貸切シミュレーションゴルフ施設。UNEEKOR EYE XO2搭載、1700以上のコース。',
};

function injectJsonLd(id: string, data: object) {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement('script');
    el.id = id;
    (el as HTMLScriptElement).type = 'application/ld+json';
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export default function Home() {
  useEffect(() => {
    injectJsonLd('ld-local-business', localBusinessJsonLd);
    injectJsonLd('ld-website', webSiteJsonLd);
    return () => {
      document.getElementById('ld-local-business')?.remove();
      document.getElementById('ld-website')?.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#fafafa] text-[#1a1a3e] overflow-x-hidden">
      <Header />
      <main>
        <Hero />

        {/* News Banner */}
        <div className="w-full bg-[#1a1a3e] border-b border-white/10">
          <Link
            to="/news/"
            className="flex items-center justify-between max-w-[1000px] mx-auto px-6 lg:px-10 py-3.5 group cursor-pointer"
          >
            <div className="flex items-center gap-3">
              <span className="inline-flex items-center justify-center bg-[#47d6d4] text-[#1a1a3e] text-[10px] font-bold tracking-widest px-2.5 py-1 rounded-full whitespace-nowrap uppercase">
                News
              </span>
              <span
                className="text-white/90 text-sm font-medium tracking-wide"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              >
                最新のニュースはこちら
              </span>
            </div>
            <div className="flex items-center gap-1.5 text-[#47d6d4] text-sm font-medium whitespace-nowrap transition-transform duration-200 group-hover:translate-x-1">
              <span className="hidden sm:inline text-xs tracking-wide">詳しく見る</span>
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line text-base"></i>
              </div>
            </div>
          </Link>
        </div>

        <About />
        <System />
        <Price />
        <Experience />
        <Voice />
        <Access />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
